import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import DualChatView from '@/components/Chat/DualChatView';
import { useSessionStore } from '@/stores/useSessionStore';
import { useChatStore } from '@/stores/useChatStore';
import { useConfigStore } from '@/stores/useConfigStore';
import { getSession } from '@/api/sessions';

/**
 * 对话主页面。
 * 整合 DualChatView，首次进入无会话时自动创建新会话。
 */
const ChatPage: React.FC = () => {
  const sessions = useSessionStore((s) => s.sessions);
  const currentSession = useSessionStore((s) => s.currentSession);
  const loadingSessions = useSessionStore((s) => s.loading);
  const createSession = useSessionStore((s) => s.createSession);
  const loadSessions = useSessionStore((s) => s.loadSessions);
  const clearMessages = useChatStore((s) => s.clearMessages);
  const setMessages = useChatStore((s) => s.setMessages);
  const setError = useChatStore((s) => s.setError);
  const loadConfig = useConfigStore((s) => s.loadConfig);

  // 进入聊天页时加载后端生产配置，避免显示或使用前端默认模型。
  useEffect(() => {
    loadConfig();
  }, [loadConfig]);

  // 首次加载会话列表
  useEffect(() => {
    loadSessions();
  }, [loadSessions]);

  // 无会话时自动创建
  useEffect(() => {
    if (!loadingSessions && sessions.length === 0 && !currentSession) {
      createSession('新会话');
    }
  }, [sessions, currentSession, loadingSessions, createSession]);

  // 切换会话时加载历史消息
  useEffect(() => {
    let cancelled = false;
    const sessionId = currentSession?.session_id;
    if (!sessionId) {
      clearMessages();
      return;
    }

    getSession(sessionId)
      .then((session) => {
        if (!cancelled) {
          setMessages(session.messages || []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          clearMessages();
          setError(err instanceof Error ? err.message : '加载历史消息失败');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [currentSession?.session_id, clearMessages, setMessages, setError]);

  return (
    <Box sx={{ height: '100%', overflow: 'hidden' }}>
      <DualChatView />
    </Box>
  );
};

export default ChatPage;
